import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, isRef as _isRef, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ef736d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mod_wrap mod_set_wrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mod_c_title" }, "页面装饰", -1))
const _hoisted_3 = {
  key: 1,
  class: "view_worp"
}
const _hoisted_4 = { class: "container_content" }
const _hoisted_5 = { class: "left_box" }
const _hoisted_6 = { class: "senior_worp_left_type" }
const _hoisted_7 = {
  key: 0,
  class: "worp_left"
}
const _hoisted_8 = {
  key: 1,
  class: "worp_left_m"
}
const _hoisted_9 = { class: "worp_right" }
const _hoisted_10 = {
  key: 0,
  class: "right_item"
}
const _hoisted_11 = { class: "right_item line_set" }
const _hoisted_12 = { class: "icon_imgs" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "LOGO设置:", -1))
const _hoisted_14 = { class: "text_upload" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "建议200*200", -1))
const _hoisted_16 = { class: "icon_Livecover" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "播放器封面:", -1))
const _hoisted_18 = { class: "text_upload" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "建议尺寸1920*1080小于2M", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "(支持JPG,GIF,PNG,BMP)", -1))
const _hoisted_21 = { class: "right_item line_style" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "channer_title" }, "全局风格：", -1))
const _hoisted_23 = { class: "channer_box" }
const _hoisted_24 = { class: "channer_colorselector" }
const _hoisted_25 = { class: "theme_title" }
const _hoisted_26 = { class: "footer_button" }
const _hoisted_27 = { class: "channer_fixed" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = ["src"]
const _hoisted_30 = { class: "channer_fixed_txt" }
const _hoisted_31 = { class: "right_item" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "PC页面背景:", -1))
const _hoisted_33 = { class: "channer_box" }
const _hoisted_34 = { class: "channer_backselect" }
const _hoisted_35 = { class: "theme_title" }
const _hoisted_36 = { class: "footer_button" }
const _hoisted_37 = { class: "pc_upload" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "建议尺寸1920*1080小于2M", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "(支持JPG,GIF,PNG,BMP)", -1))
const _hoisted_40 = {
  key: 1,
  class: "sub_form"
}
const _hoisted_41 = { class: "more_modal" }
const _hoisted_42 = { class: "more_modal_box" }
const _hoisted_43 = ["onClick"]
const _hoisted_44 = ["src"]
const _hoisted_45 = { class: "channer_fixed_txt" }
const _hoisted_46 = { class: "more_modal_cus" }
const _hoisted_47 = { class: "content_gird" }
const _hoisted_48 = ["onClick"]
const _hoisted_49 = { class: "gird_item_box" }
const _hoisted_50 = { class: "gird_item_top" }
const _hoisted_51 = { class: "gird_hover" }
const _hoisted_52 = { class: "gird_hover_con" }
const _hoisted_53 = { class: "btn_action" }
const _hoisted_54 = { class: "btn_action_box" }
const _hoisted_55 = { class: "gird_item_top_box" }
const _hoisted_56 = { class: "gird_item_top_img" }
const _hoisted_57 = ["src"]
const _hoisted_58 = { class: "gird_item_txt" }
const _hoisted_59 = { key: 0 }

import CDelModal, { RootModal } from '@/components/CDelModal.vue';
import { ref, reactive, computed, unref, inject, defineAsyncComponent, nextTick } from 'vue';
import { message, Form, Button, Tabs, Switch, Radio, Modal, Image } from 'ant-design-vue';
import CUpload from '@/components/CUpload.vue';
import { RedoOutlined, CheckCircleFilled, RightOutlined } from '@ant-design/icons-vue';
import Crumb from '@/components/Crumb.vue';
import { ElColorPicker } from 'element-plus';
import http from '@/api/pagedirect';
import router from '@/router';
import { LiveInfo } from '@/store/modules/live/types';
import { useStore } from 'vuex';
import CLoading from '@/components/CLoading.vue';
import { pageStyle1, pageStyle2, pageStyle3, pageStyle4, pageStyle5 } from '@/assets';
import { ModalData, PcStyleSet, PcTemplate, StyleList } from './PageChild/type';
import { useDebounce } from '@/hooks/useDebounce'; //防抖
import CDelModalVue from '@/components/CDelModal.vue';
import { emptyDataSec } from '@/assets';

interface FileItem {
  uid: string;
  name?: string;
  status?: string;
  response?: any;
  url?: string;
  type?: string;
  size: number;
  originFileObj: never;
}
interface FileInfo {
  file: FileItem;
  fileList: FileItem[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PageDirector',
  setup(__props) {

const SeniorSet = defineAsyncComponent(() => import('./PageChild/SeniorSet.vue'));
const PreviewPc = defineAsyncComponent(() => import('./PageChild/PreviewPc.vue'));
const aFormItem = Form.Item;
const aButton = Button;
const aTabs = Tabs;
const aTabPane = Tabs.TabPane;
const aSwitch = Switch;
const aRadio = Radio;
const aRadioGroup = Radio.Group;
const aModal = Modal;
const aImage = Image;
const liveInfo = computed(() => unref(inject('liveInfo')) as LiveInfo);
const PreviewMobile = defineAsyncComponent(() => import('./PageChild/PreviewMobile.vue'));
const studioId = router.currentRoute.value.params.studioId;

const activeKey = ref('1');
const styleGlobal = reactive([
  { key: 0, url: pageStyle1, title: '浅色风格' },
  { key: 1, url: pageStyle2, title: '暗色风格' },
  { key: 2, url: pageStyle4, title: '年会风格' },
  { key: 3, url: pageStyle3, title: '科技风格' },
  { key: 4, url: pageStyle5, title: '财经风格' },
]);
const clickSet = () => {
  // if (activeKey.value === '2') {
  //   childRef.value.getPCStyles();
  // }
};
let data: ModalData = {
  pcBgUrl: '',
  logoUrl: '',
  topShow: false,
  titleColor: '#333333',
  textColor1: '#505D6F',
  topBbColor: '#FFFFFF',
  videoCv: '',
  pcBgColor: '#E5E7EB',
  themeColor: '#00CCB0',
  textColor2: '#333333',
  tabBgColor: '#FFFFFF',
  pc_botton_bg: '#FFFFFF',
  msgBgColor: '#F7F9Fc',
  sendBgColor: '#F2F4F8',
  menuBgColor: '#FFFFFF',
  tabTitleColor: '#505D6F',
  msgColor: '#FFFFFF',
  sendColor: '#EBEEF5',
  type: '0',
  mobile_bg: '#FFFFFF',
  mobile_meau_bg: '#FFFFFF ',
  mobile_meau_color: '#505D6F',
  mobile_send_bg: '#FFFFFF',
};
const tabsKey = ref(0);
const allKey = ref(0);
const clickTabs = (index: number) => {
  tabsKey.value = index;
  allKey.value = index;
  // 0 默认 浅色  1 深色  2科技  3年会 4财经
  if (liveInfo.value.mode == 4 && liveInfo.value.studio_pid == liveInfo.value.id) {
    deletes.value = true;
    choice.value = 6;
  }
  clickStyles(index);
};

const is_Show = computed(() => liveInfo.value.mode === 4 && liveInfo.value.studio_pid === liveInfo.value.id);

const onDataClear = () => {
  data.pc_top_bgimg = data.pc_tab_bgimg = data.pc_meau_bgimg = data.mobile_tab_bgimg = '';
  styleList.value[0].image_url = styleList.value[1].image_url = styleList.value[2].image_url = styleList.value[3].image_url = '';
  styleList.value[0].opacity = styleList.value[1].opacity = styleList.value[2].opacity = styleList.value[3].opacity = 100;
  data.opacity_pc_0 = data.opacity_mobile_0 = data.opacity_mobile_1 = data.opacity_pc_3 = data.opacity_pc_2 = 1;
};
const colour_bg = ref('');
const clickStyles = (index: number, resColour?: any, resColor?: any) => {
  switch (index) {
    case 0:
      if (resColor) {
        colour_bg.value = colour.value = resColour;
        color.value = resColor;
      } else {
        colour_bg.value = colour.value = '#E5E7EB';
        color.value = '#00CCB0';
      }
      onDataClear();
      data.pc_msg_bgimg = data.mobile_msg_bgimg = '';
      data.textColor2 = '#333333';
      data.msgBgColor = '#F7F9Fc';
      data.msgColor = data.menuBgColor = data.tabBgColor = data.topBbColor = data.mobile_meau_bg = '#FFFFFF';
      styleList.value[0].bg_color = data.topBbColor;
      styleList.value[1].bg_color = data.tabBgColor;
      styleList.value[2].bg_color = data.msgBgColor;
      styleList.value[3].bg_color = data.menuBgColor;
      data.mobile_bg = 'transparent';
      data.sendColor = '#606266';
      break;
    case 1:
      if (resColor) {
        colour_bg.value = colour.value = resColour;
        color.value = resColor;
      } else {
        color.value = '#00CCB0';
        colour_bg.value = colour.value = '#030A13';
      }
      onDataClear();
      data.pc_msg_bgimg = data.mobile_msg_bgimg = '';
      styleList.value[0].bg_color = data.topBbColor = '#192431';
      data.textColor2 = '#A4B3CA';
      data.msgBgColor = data.mobile_bg = '#121B25';
      styleList.value[1].bg_color = data.menuBgColor = data.tabBgColor = data.mobile_meau_bg = '#232F3B';
      data.msgColor = '#E2E8F0';
      data.sendColor = '#FFFFFF';
      styleList.value[2].bg_color = data.msgBgColor;
      styleList.value[3].bg_color = data.menuBgColor;
      break;
    case 2:
      if (resColor) {
        colour_bg.value = colour.value = resColour;
        color.value = resColor;
      } else {
        color.value = '#F2C277';
        colour_bg.value = colour.value = '#D0514C';
      }
      onDataClear();
      data.pc_msg_bgimg = data.mobile_msg_bgimg = process.env.VUE_APP_OTHER_LINK+'/ab4c720220722133615203.png';
      styleList.value[2].image_url = data.pc_msg_bgimg;
      styleList.value[0].bg_color = data.topBbColor = data.tabBgColor = data.mobile_meau_bg = data.menuBgColor = '#D82737';
      styleList.value[1].bg_color = data.tabBgColor;
      data.textColor2 = data.msgColor = data.sendColor = '#FFFFFF';
      data.msgBgColor = data.mobile_bg = '#CA2433';
      styleList.value[2].bg_color = data.msgBgColor;
      styleList.value[3].bg_color = data.menuBgColor;
      break;
    case 3:
      if (resColor) {
        colour_bg.value = colour.value = resColour;
        color.value = resColor;
        if (resColour === '#016891') {
          colour_bg.value = 'linear-gradient(135deg, #016891, #012045 30%, #012045 75%, #005c80 100%)';
        }
      } else {
        colour.value = '#016891';
        color.value = '#00CCB0';
        colour_bg.value = 'linear-gradient(135deg, #016891, #012045 30%, #012045 75%, #005c80 100%)';
      }
      onDataClear();
      data.pc_msg_bgimg = data.mobile_msg_bgimg = '';
      styleList.value[0].bg_color = data.topBbColor = '#002C50';
      data.textColor2 = data.msgColor = data.sendColor = '#FFFFFF';
      data.menuBgColor = '#0A486C';
      data.msgBgColor = data.mobile_bg = 'linear-gradient(138deg, #065b80 0%, #061e43 51%, #035c82 100%)';
      data.tabBgColor = data.mobile_meau_bg = 'linear-gradient(132deg, #0a81a9 0%, #0a4367 100%)';
      styleList.value[1].bg_color = styleList.value[2].bg_color = '#016891';
      styleList.value[3].bg_color = data.menuBgColor;
      break;
    case 4:
      if (resColor) {
        colour_bg.value = colour.value = resColour;
        color.value = resColor;
      } else {
        colour_bg.value = colour.value = '#000000';
        color.value = '#FBD793';
      }
      onDataClear();
      data.pc_msg_bgimg = data.mobile_msg_bgimg = '';
      styleList.value[0].bg_color = data.topBbColor = '#0A1626';
      styleList.value[1].bg_color = data.menuBgColor = data.tabBgColor = data.mobile_meau_bg = '#162231';
      data.msgBgColor = data.mobile_bg = '#0A1626';
      styleList.value[2].bg_color = data.msgBgColor;
      styleList.value[3].bg_color = data.menuBgColor;
      data.sendColor = '#FFFFFF';
  }
  data.type = String(index);
};
const childRef = ref();

const moreModel = reactive<RootModal>({
  title: '更多',
  visible: false,
  loading: false,
});
const moreKey = ref('1');
const openMoreModel = () => {
  moreModel.visible = !moreModel.visible;
  if (moreModel.visible) {
    pageConfigure.current = 1;
    PcTemplateList.value = [];
    getTemplate();
  }
};

// 获取模板库
const PcTemplateList = ref<PcTemplate[]>([]);
// 分页
const pageConfigure = reactive({
  current: 1, // 当前页
  pageSize: 10, // 每页条数
  totalSize: 0, // 总数
});
const getTemplate = () => {
  const data = { page: pageConfigure.current, page_num: pageConfigure.pageSize };
  http
    .getTemplateList({ params: data })
    .then((res) => {
      const resData = res.data.data;
      pageConfigure.totalSize = resData.total;
      PcTemplateList.value = PcTemplateList.value.concat(resData.data);
    })
    .catch((err) => message.error(err.data.error));
};
const scrollEventPc = () => {
  // 滚动条距离顶部的距离 + // 滚动条外容器的高度 >=   滚动条高度
  if (pageConfigure.totalSize && PcTemplateList.value.length < pageConfigure.totalSize) {
    pageConfigure.current = pageConfigure.current + 1;
    getTemplate();
  }
};
// 删除模板
const delModal = reactive<RootModal>({
  title: '删除',
  visible: false,
  loading: false,
});
const delId = ref();
const openDelModal = (id: number) => {
  delId.value = id;
  delModal.visible = true;
};
const closeDelModal = () => {
  delModal.visible = false;
};
const delClick = () => {
  let data = { id: delId.value };
  http
    .delTemplate(data)
    .then((res) => {
      message.success(res.data.message);
      closeDelModal();
      pageConfigure.current = 1;
      PcTemplateList.value = [];
      getTemplate();
      delId.value = '';
    })
    .catch((err) => message.error(err.data.error));
};
const clickModalTabs = (index: number) => {
  tabsKey.value = index;
  allKey.value = index;
  // 0 默认 浅色  1 深色  2科技  3年会
};
const item = ref();
const moreCusKey = ref();
const useButton = (element: PcTemplate, index: number) => {
  item.value = element;
  moreCusKey.value = index;
};
// pc 保存
const styleList = ref<PcStyleSet[]>([
  {
    type_name: 'navigation',
    bg_color: '#FFFFFF',
    opacity: 100,
    image_url: '',
  },
  {
    type_name: 'tab_bar',
    bg_color: '#FFFFFF',
    opacity: 100,
    image_url: '',
  },
  {
    type_name: 'chat_room',
    bg_color: '#FFFFFF',
    opacity: 100,
    image_url: '',
  },
  {
    type_name: 'content_bar',
    bg_color: '#FFFFFF',
    opacity: 100,
    image_url: '',
  },
]);
const moreSave = () => {
  let data = {
    studio_id: studioId,
    style_settings: JSON.stringify(styleList.value),
    dark_mode: dataSource.value.type,
    theme_color: dataSource.value.themeColor,
    image_bg_id: dataSource.value.image_id,
    bg_color: dataSource.value.color_ke,
  };
  http
    .setPcDecorate(data)
    .then((res) => {
      message.destroy();
    })
    .catch((err) => message.error(err.data.error));
};

const moreHandleOk = () => {
  if (moreKey.value === '1') {
    clickStyles(tabsKey.value);
  } else {
    nextTick(() => {
      data.type = item.value.dark_mode.toString();
      tabsKey.value = item.value.dark_mode;
      data.themeColor = color.value = item.value.theme_color;
      data.pcBgUrl = obj.value.defaultcover = item.value.image_bg_url;
      data.pcBgColor = colour.value = colour_bg.value = item.value.bg_color;
      if (item.value.bg_color === '#016891') {
        colour_bg.value = 'linear-gradient(135deg, #016891, #012045 30%, #012045 75%, #005c80 100%)';
      }
      data.image_id = pageId.value.image_bg_id = String(item.value.image_bg_id);

      data.mobile_meau_bg = data.tabBgColor = styleList.value[1].bg_color = item.value.style_info[1].bg_color;
      data.mobile_tab_bgimg = data.pc_tab_bgimg = styleList.value[1].image_url = item.value.style_info[1].image_url;
      data.opacity_mobile_0 = data.opacity_pc_1 = (styleList.value[1].opacity = item.value.style_info[1].opacity) / 100;

      data.mobile_bg = data.msgBgColor = styleList.value[2].bg_color = item.value.style_info[2].bg_color;
      styleList.value[2].image_url = item.value.style_info[2].image_url;
      data.pc_msg_bgimg = item.value.style_info[2].image_url;
      data.mobile_msg_bgimg = item.value.style_info[2].image_url;
      data.opacity_mobile_1 = data.opacity_pc_2 = (styleList.value[2].opacity = item.value.style_info[2].opacity) / 100;

      data.menuBgColor = styleList.value[3].bg_color = item.value.style_info[3].bg_color;
      data.pc_meau_bgimg = styleList.value[3].image_url = item.value.style_info[3].image_url;
      data.opacity_pc_3 = (styleList.value[3].opacity = item.value.style_info[3].opacity) / 100;

      data.topBbColor = styleList.value[0].bg_color = item.value.style_info[0].bg_color;
      data.pc_top_bgimg = styleList.value[0].image_url = item.value.style_info[0].image_url;
      data.opacity_pc_0 = (styleList.value[0].opacity = item.value.style_info[0].opacity) / 100;
    });
  }
  if (liveInfo.value.mode == 4 && liveInfo.value.studio_pid == liveInfo.value.id) {
    deletes.value = true;
    choice.value = 6;
  } else {
    keep(true);
  }
  openMoreModel();
};

const dataSource = computed(() => {
  let resData: ModalData = {
    ...data,
    topShow: Options.value,
    logoUrl: obj.value.siteicon,
    videoCv: obj.value.Navigationlogo,
    themeColor: color.value,
    pcBgColor: colour_bg.value,
    pcBgUrl: obj.value.defaultcover,
    image_id: pageId.value.image_bg_id,
    color_ke: colour.value,
    allKey: allKey.value,
    styleList: styleList.value,
  };
  return resData;
});

const updataList = (resData: ModalData, styleLists: StyleList[]) => {
  color.value = resData.themeColor;
  tabsKey.value = Number(resData.type);
  obj.value.defaultcover = resData.pcBgUrl ? resData.pcBgUrl : '';
  pageId.value.image_bg_id = resData.image_id;
  colour.value = colour_bg.value = resData.pcBgColor;
  if (resData.pcBgColor === '#016891') {
    colour_bg.value = 'linear-gradient(135deg, #016891, #012045 30%, #012045 75%, #005c80 100%)';
  }
  data = resData;
  styleList.value = styleLists;
};

const resType = ref(1);
const updataStreamTheme = () => {
  const data = {
    studio_id: studioId,
    dark_mode: tabsKey.value,
    theme_color: color.value,
    bg_color: colour.value,
    is_clear: resType.value,
  };
  http
    .updataStreamTheme(data)
    .then((res) => {
      message.success(res.data.message);
    })
    .catch((err) => message.error(err.data.error));
};

const deletes = ref(false);

const store = useStore();
const topLogo = computed(() => store.state.home.customData.top_logo_url);
// 多语言权限
const fileList = ref();
const loading = reactive({
  logoLoading: false,
  coverLoding: false,
  bgLoading: false,
});
const choiceImage = ref();
const handleChange = (info: FileInfo, type: number, keyword: string) => {
  // 这里获取proxy里的response里的id和url,通过三元判断符去获取多个同样的
  // fileList.value[fileList.value.length - 1]
  // [fileList.value.length - 1] 就是当response里有下标[0][1][2]...的时候，要去拿到最新的那一条，就去length-1，
  if (info.file.status === 'done') {
    if (info.file?.response?.code === 200) {
      type === 0
        ? ((obj.value.siteicon = info.file?.response?.data.url),
          (pageId.value.image_player_logo_id = info.file?.response?.data.id))
        : type === 1
        ? ((obj.value.Navigationlogo = info.file?.response?.data.url),
          (pageId.value.image_player_cover_id = info.file?.response?.data.id))
        : type === 2
        ? ((obj.value.defaultcover = info.file?.response?.data.url), (pageId.value.image_bg_id = info.file?.response?.data.id))
        : '';
    }
    if (liveInfo.value.mode == 4 && liveInfo.value.studio_pid == liveInfo.value.id) {
      deletes.value = true;
    }
    choiceImage.value = type;
    choice.value = 0;
  }
  if (info.file.status === 'uploading') {
    loading[keyword] = true;
    return;
  } else {
    loading[keyword] = false;
  }
};

const clearImg = (type: number) => {
  if (liveInfo.value.mode == 4 && liveInfo.value.studio_pid == liveInfo.value.id) {
    switch (type) {
      case 0:
        obj.value.siteicon = '';
        pageId.value.image_player_logo_id = '';

        streamThemePlayerLogo();
        break;
      case 1:
        obj.value.Navigationlogo = '';
        pageId.value.image_player_cover_id = '';
        streamThemePlayerCover();

        break;
      default:
        obj.value.defaultcover = '';
        pageId.value.image_bg_id = '';
        streamThemeImageBg();

        break;
    }
  } else if (liveInfo.value.mode != 4 || liveInfo.value.studio_pid != liveInfo.value.id) {
    switch (type) {
      case 0:
        obj.value.siteicon = '';
        pageId.value.image_player_logo_id = '';

        break;
      case 1:
        obj.value.Navigationlogo = '';
        pageId.value.image_player_cover_id = '';

        break;
      default:
        obj.value.defaultcover = '';
        pageId.value.image_bg_id = '';

        break;
    }
  }
};
let pageId = ref({
  image_bg_id: '',
  image_player_logo_id: '',
  image_player_cover_id: '',
  header_switch: '',
});
// 保存
const keep = useDebounce((type: any) => {
  // 0 清空  1不清空
  if (type) moreSave();
  let themes = {
    studio_id: studioId,
    header_status: Number(Options.value),
    bg_color: colour.value,
    theme_color: color.value,
    image_bg_id: pageId.value.image_bg_id,
    image_player_logo_id: pageId.value.image_player_logo_id,
    image_player_cover_id: pageId.value.image_player_cover_id,
    dark_mode: tabsKey.value,
    is_clear: 1,
  };
  resType.value = type ? 0 : 1;
  http
    .getTheme(themes)
    .then((res) => {
      const resData = res.data;
      message.destroy();
      if (type) message.success(resData.message);
    })
    .catch((res) => {
      console.error(res.data.error);
    });
});
const Options = ref(false);
// 颜色选择器显示/隐藏
const colorList = ref(['#00CCB0', '#1890FF', '#FF4D4F', '#FF9337', '#FBD793']);
const color = ref(colorList.value[0]);
const colour = ref('#F5F5F5');

const choice = ref();
const selectced = (index: any) => {
  if (index === 4) colour_bg.value = colour.value;
  if (liveInfo.value.mode == 4 && liveInfo.value.studio_pid == liveInfo.value.id) {
    deletes.value = true;
    choice.value = index;
    choiceImage.value = 3;
  }
};
// 重置
const reset = (type: number) => {
  switch (type) {
    case 1:
      if (tabsKey.value === 2) color.value = '#F2C277';
      else color.value = colorList.value[0];
      if (tabsKey.value === 4) {
        color.value = '#FBD793';
      }
      break;
    case 2:
      if (tabsKey.value === 0) {
        colour.value = '#E5E7EB';
      } else if (tabsKey.value === 1) {
        colour.value = '#030A13';
      } else if (tabsKey.value === 2) {
        colour.value = '#D0514C';
      } else if (tabsKey.value === 3) {
        colour.value = '#016891';
      } else if (tabsKey.value === 4) {
        colour.value = '#000000';
      }
      colour_bg.value = colour.value;
      if (tabsKey.value === 3) colour_bg.value = 'linear-gradient(135deg, #016891, #012045 30%, #012045 75%, #005c80 100%)';
      break;
  }
};
let obj = ref({
  siteicon: '',
  Navigationlogo: '',
  defaultcover: '',
});
const showLoading = ref(false);
// 直播间详情
const viewDetails = () => {
  showLoading.value = true;
  let detail = {
    studio_id: studioId,
  };
  http
    .getviewDetails({ params: detail })
    .then((res) => {
      Options.value = res.data.data.header_status ? true : false;
      obj.value.siteicon = res.data.data.image_player_logo_url;
      obj.value.Navigationlogo = res.data.data.image_player_cover_url;
      obj.value.defaultcover = res.data.data.image_bg_url;
      pageId.value.header_switch = res.data.data.header_switch;
      pageId.value.image_bg_id = res.data.data.image_bg_id;
      pageId.value.image_player_logo_id = res.data.data.image_player_logo_id;
      pageId.value.image_player_cover_id = res.data.data.image_player_cover_id;
      tabsKey.value = res.data.data.dark_mode;
      colour.value = res.data.data.bg_color;
      color.value = res.data.data.theme_color;
      clickStyles(tabsKey.value, colour.value, color.value);
    })
    .finally(() => (showLoading.value = false));
};
viewDetails();
// 多频道
// 导航开关
const streamThemeHeaderStatus = () => {
  let strema = {
    header_status: Number(Options.value),
    studio_id: studioId,
  };
  http.getStreamThemeHeaderStatus(strema).then((res) => {
    const resData = res.data;
    message.success(resData.message);
  });
};
// logo设置
const streamThemePlayerLogo = () => {
  let playLogo = {
    studio_id: studioId,
    image_player_logo_id: pageId.value.image_player_logo_id,
  };

  http.getStreamThemePlayerLogo(playLogo).then((res) => {
    const resData = res.data;
    message.success(resData.message);
  });
};
//播放器封面
const streamThemePlayerCover = () => {
  let playCover = {
    studio_id: studioId,
    image_player_cover_id: pageId.value.image_player_cover_id,
  };
  http.getStreamThemePlayerCover(playCover).then((res) => {
    const resData = res.data;
    message.success(resData.message);
  });
};
// PC页面背景
const streamThemeImageBg = () => {
  let imageBg = {
    studio_id: studioId,
    image_bg_id: pageId.value.image_bg_id,
  };
  http.getStreamThemeImageBg(imageBg).then((res) => {
    const resData = res.data;
    if (choice.value !== 6) message.success(resData.message);
  });
};
// 频道配色
const streamThemeColor = () => {
  let themeColor = {
    studio_id: studioId,
    theme_color: color.value,
  };
  http.getStreamThemeColor(themeColor).then((res) => {
    const resData = res.data;
    message.success(resData.message);
  });
};
// 背景色
const streamThemeBgColor = () => {
  let bgColor = {
    studio_id: liveInfo.value.id,
    bg_color: colour.value,
  };
  http.getStreamThemeBgColor(bgColor).then((res) => {
    const resData = res.data;
    if (choice.value !== 6) message.success(resData.message);
  });
};
const preview = ref('1');

// 弹框
const openModal = () => {
  deletes.value = false;
};
const ConfirmDelete = () => {
  deletes.value = false;
  if (liveInfo.value.mode == 4 && liveInfo.value.studio_pid == liveInfo.value.id) {
    if (choice.value == 1) {
      streamThemeHeaderStatus(); //导航开关
    }
    if (choice.value == 2) {
      streamThemeColor();
    }
    if (choice.value == 3) {
      streamThemeColor(); //频道配色
    }
    if (choice.value == 4) {
      streamThemeBgColor(); //背景
    }
    if (choiceImage.value == 0) {
      streamThemePlayerLogo();
    }
    if (choiceImage.value == 1) {
      streamThemePlayerCover();
    }
    if (choiceImage.value == 2) {
      streamThemeImageBg();
    }
    if (choice.value == 5) {
      updataStreamTheme();
    }
    if (choice.value == 6) {
      updataStreamTheme();
      streamThemeBgColor();
      streamThemeImageBg();
      // nextTick(() => {
      moreSave();
      // });
    }
  }
};

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _directive_infinite_scroll = _resolveDirective("infinite-scroll")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Crumb),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      (showLoading.value)
        ? (_openBlock(), _createBlock(CLoading, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_unref(aTabs), {
              activeKey: activeKey.value,
              "onUpdate:activeKey": _cache[12] || (_cache[12] = ($event: any) => ((activeKey).value = $event)),
              type: "card",
              onChange: clickSet
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(aTabPane), {
                  key: "1",
                  tab: "全局配置"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                          _createTextVNode(" 预览： "),
                          _createVNode(_unref(aRadioGroup), {
                            name: "radioGroup",
                            value: preview.value,
                            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((preview).value = $event))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(aRadio), { value: "1" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("PC预览页面")
                                ]),
                                _: 1
                              }),
                              _createVNode(_unref(aRadio), { value: "2" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("手机预览页面")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ]),
                        (preview.value === '1')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                              _createElementVNode("div", {
                                class: "content_image",
                                style: _normalizeStyle({ background: colour.value })
                              }, [
                                _createVNode(_unref(PreviewPc), {
                                  modelValue: _unref(dataSource),
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(dataSource) ? (dataSource).value = $event : null))
                                }, null, 8, ["modelValue"])
                              ], 4)
                            ]))
                          : _createCommentVNode("", true),
                        (preview.value === '2')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                              _createVNode(_unref(PreviewMobile), {
                                modelValue: _unref(dataSource),
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(dataSource) ? (dataSource).value = $event : null))
                              }, null, 8, ["modelValue"])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        (_unref(pageId).header_switch)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                              _createVNode(_unref(aFormItem), { label: "推广注册" }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(aSwitch), {
                                    checked: Options.value,
                                    "onUpdate:checked": _cache[3] || (_cache[3] = ($event: any) => ((Options).value = $event)),
                                    onChange: _cache[4] || (_cache[4] = ($event: any) => (selectced(1)))
                                  }, null, 8, ["checked"])
                                ]),
                                _: 1
                              })
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("div", _hoisted_12, [
                            _hoisted_13,
                            _createElementVNode("div", _hoisted_14, [
                              _createVNode(CUpload, {
                                "file-list": fileList.value,
                                "handle-change": (info) => handleChange(info, 0, 'logoLoading'),
                                loading: loading.logoLoading,
                                "image-name": _unref(obj).siteicon,
                                "click-stop": () => clearImg(0),
                                class: "upload_img"
                              }, {
                                uploadImg: _withCtx(() => [
                                  _hoisted_15
                                ]),
                                _: 1
                              }, 8, ["file-list", "handle-change", "loading", "image-name", "click-stop"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_16, [
                            _hoisted_17,
                            _createElementVNode("div", _hoisted_18, [
                              _createVNode(CUpload, {
                                "file-list": fileList.value,
                                "handle-change": (info) => handleChange(info, 1, 'coverLoding'),
                                loading: loading.coverLoding,
                                "image-name": _unref(obj).Navigationlogo,
                                "click-stop": () => clearImg(1),
                                class: "ant_upload"
                              }, {
                                uploadImg: _withCtx(() => [
                                  _hoisted_19,
                                  _hoisted_20
                                ]),
                                _: 1
                              }, 8, ["file-list", "handle-change", "loading", "image-name", "click-stop"])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                          _hoisted_22,
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("div", _hoisted_24, [
                              _createElementVNode("div", _hoisted_25, "主题颜色： " + _toDisplayString(color.value), 1),
                              _createVNode(_unref(ElColorPicker), {
                                modelValue: color.value,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((color).value = $event)),
                                predefine: colorList.value,
                                size: "mini",
                                onChange: _cache[6] || (_cache[6] = ($event: any) => (selectced(3)))
                              }, null, 8, ["modelValue", "predefine"])
                            ]),
                            _createElementVNode("div", _hoisted_26, [
                              _createVNode(_unref(aButton), {
                                class: "btn_reset",
                                onClick: _cache[7] || (_cache[7] = ($event: any) => (reset(1)))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("重置"),
                                  _createVNode(_unref(RedoOutlined))
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_27, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(styleGlobal, (item) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: item.key,
                                class: _normalizeClass(["channer_fixed_img", { actived: tabsKey.value === item.key }]),
                                onClick: ($event: any) => (clickTabs(item.key))
                              }, [
                                _createElementVNode("img", {
                                  src: item.url
                                }, null, 8, _hoisted_29),
                                _createElementVNode("div", _hoisted_30, _toDisplayString(item.title), 1),
                                _withDirectives(_createVNode(_unref(CheckCircleFilled), { class: "channer_fixed_icon" }, null, 512), [
                                  [_vShow, tabsKey.value === item.key]
                                ])
                              ], 10, _hoisted_28))
                            }), 128)),
                            _createElementVNode("div", {
                              class: "channer_fixed_img channer_fixed_more",
                              onClick: openMoreModel
                            }, [
                              _createTextVNode("更多 "),
                              _createVNode(_unref(RightOutlined))
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_31, [
                          _hoisted_32,
                          _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("div", _hoisted_34, [
                              _createElementVNode("div", _hoisted_35, "背景颜色： " + _toDisplayString(colour.value), 1),
                              _createVNode(_unref(ElColorPicker), {
                                modelValue: colour.value,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((colour).value = $event)),
                                predefine: colorList.value,
                                size: "mini",
                                onChange: _cache[9] || (_cache[9] = ($event: any) => (selectced(4)))
                              }, null, 8, ["modelValue", "predefine"])
                            ]),
                            _createElementVNode("div", _hoisted_36, [
                              _createVNode(_unref(aButton), {
                                class: "btn_reset",
                                onClick: _cache[10] || (_cache[10] = ($event: any) => (reset(2)))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("重置"),
                                  _createVNode(_unref(RedoOutlined))
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_37, [
                            _createVNode(CUpload, {
                              "file-list": fileList.value,
                              "handle-change": (info) => handleChange(info, 2, 'bgLoading'),
                              loading: loading.bgLoading,
                              "image-name": _unref(obj).defaultcover,
                              "click-stop": () => clearImg(2),
                              class: "pc_backimg"
                            }, {
                              uploadImg: _withCtx(() => [
                                _hoisted_38,
                                _hoisted_39
                              ]),
                              _: 1
                            }, 8, ["file-list", "handle-change", "loading", "image-name", "click-stop"])
                          ])
                        ]),
                        (_unref(liveInfo).mode != 4 || _unref(liveInfo).studio_pid != _unref(liveInfo).id)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                              _createVNode(_unref(aButton), {
                                type: "primary",
                                onClick: _unref(keep)
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("保存")
                                ]),
                                _: 1
                              }, 8, ["onClick"])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(aTabPane), {
                  key: "2",
                  tab: "高级配置",
                  "force-render": ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(SeniorSet), {
                      modelValue: _unref(dataSource),
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_isRef(dataSource) ? (dataSource).value = $event : null)),
                      ref_key: "childRef",
                      ref: childRef,
                      "onUpdata:data": updataList,
                      onRefresh: _unref(keep)
                    }, null, 8, ["modelValue", "onRefresh"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["activeKey"])
          ])),
      _createVNode(CDelModal, {
        visible: deletes.value,
        centered: "",
        close: openModal,
        ok: ConfirmDelete
      }, {
        title: _withCtx(() => [
          _createTextVNode("该操作将覆盖所有子直播间的该项配置，是否继续？")
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_unref(aModal), {
        visible: moreModel.visible,
        "onUpdate:visible": _cache[14] || (_cache[14] = ($event: any) => ((moreModel.visible) = $event)),
        title: moreModel.title,
        width: 670,
        centered: "",
        onOk: moreHandleOk
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_41, [
            _createVNode(_unref(aTabs), {
              activeKey: moreKey.value,
              "onUpdate:activeKey": _cache[13] || (_cache[13] = ($event: any) => ((moreKey).value = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(aTabPane), {
                  key: "1",
                  tab: "系统模板"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_42, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(styleGlobal, (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: item.key,
                          class: _normalizeClass(["more_modal_img", { actived: tabsKey.value === item.key }]),
                          onClick: ($event: any) => (clickModalTabs(item.key))
                        }, [
                          _createElementVNode("img", {
                            src: item.url
                          }, null, 8, _hoisted_44),
                          _createElementVNode("div", _hoisted_45, _toDisplayString(item.title), 1),
                          _withDirectives(_createVNode(_unref(CheckCircleFilled), { class: "channer_fixed_icon" }, null, 512), [
                            [_vShow, tabsKey.value === item.key]
                          ])
                        ], 10, _hoisted_43))
                      }), 128))
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(aTabPane), {
                  key: "2",
                  tab: "自定义模板"
                }, {
                  default: _withCtx(() => [
                    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_46, [
                      _createElementVNode("div", _hoisted_47, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(PcTemplateList.value, (item, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: _normalizeClass(["gird_item", { actived: moreCusKey.value === item.id }]),
                            key: index,
                            onClick: ($event: any) => (useButton(item, item.id))
                          }, [
                            _withDirectives(_createVNode(_unref(CheckCircleFilled), { class: "channer_fixed_icon" }, null, 512), [
                              [_vShow, moreCusKey.value === item.id]
                            ]),
                            _createElementVNode("div", _hoisted_49, [
                              _createElementVNode("div", _hoisted_50, [
                                _createElementVNode("div", _hoisted_51, [
                                  _createElementVNode("div", _hoisted_52, [
                                    _createElementVNode("div", _hoisted_53, [
                                      _createElementVNode("div", _hoisted_54, [
                                        _createVNode(_component_svg_icon, {
                                          "icon-class": "pageDirector_see",
                                          class: "icon"
                                        }),
                                        _createVNode(_unref(aImage), {
                                          src: item.preview_image,
                                          class: "btn_read"
                                        }, null, 8, ["src"]),
                                        _createVNode(_component_svg_icon, {
                                          "icon-class": "pageDirector_del",
                                          class: "icon",
                                          onClick: ($event: any) => (openDelModal(item.id))
                                        }, null, 8, ["onClick"])
                                      ])
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_55, [
                                  _createElementVNode("div", _hoisted_56, [
                                    (item.preview_image)
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 0,
                                          src: item.preview_image
                                        }, null, 8, _hoisted_57))
                                      : _createCommentVNode("", true)
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_58, _toDisplayString(item.name), 1)
                            ])
                          ], 10, _hoisted_48))
                        }), 128))
                      ]),
                      (PcTemplateList.value.length === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                            _createVNode(_component_a_empty, {
                              class: "empty_wrap",
                              image: _unref(emptyDataSec),
                              description: "页面暂无数据信息~"
                            }, null, 8, ["image"])
                          ]))
                        : _createCommentVNode("", true)
                    ])), [
                      [_directive_infinite_scroll, scrollEventPc]
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["activeKey"])
          ])
        ]),
        _: 1
      }, 8, ["visible", "title"]),
      _createVNode(CDelModalVue, {
        visible: delModal.visible,
        centered: true,
        loading: delModal.loading,
        close: closeDelModal,
        ok: delClick
      }, null, 8, ["visible", "loading"])
    ])
  ], 64))
}
}

})